export const MEGA_MENU_CSS = `
  .mm-cruises {
    position: fixed;
    top: 58px;
    left: 50vw;
    transform: translateX(-50%);
    width: min(1160px, 96vw);
    background: rgba(7,30,48,0.97);
    border: 1px solid rgba(201,165,106,0.18);
    border-top: 2px solid var(--color-gold);
    padding: 32px 36px 28px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.24s, visibility 0.24s;
    pointer-events: none;
    z-index: 999;
  }

  .mm-cruises--solid {
    top: 64px;
  }

  .mm-cruises--open {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  /* Brand columns */
  .mm-cruises__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
  }

  .mm-cruises__brand {
    padding: 0 28px 0 0;
    border-right: 1px solid rgba(201,165,106,0.1);
  }
  .mm-cruises__brand:last-child {
    padding-right: 0;
    border-right: none;
  }
  .mm-cruises__brand:not(:first-child) {
    padding-left: 28px;
  }

  .mm-cruises__brand-label {
    font-family: var(--font-sans);
    font-size: 9px;
    font-weight: 500;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    color: var(--color-gold);
    opacity: 0.75;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(201,165,106,0.12);
  }

  .mm-cruises__list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* Cruise card */
  .mm-cruise-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 10px;
    text-decoration: none;
    border: 1px solid transparent;
    transition: background 0.18s, border-color 0.18s;
    cursor: pointer;
  }

  .mm-cruise-card:hover {
    background: rgba(201,165,106,0.06);
    border-color: rgba(201,165,106,0.14);
  }

  /* Thumbnail */
  .mm-cruise-card__thumb {
    width: 60px;
    height: 80px;
    flex-shrink: 0;
    overflow: hidden;
    background: rgba(255,255,255,0.04);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mm-cruise-card__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .mm-cruise-card__thumb svg {
    opacity: 0.22;
  }

  /* Text */
  .mm-cruise-card__name {
    font-family: var(--font-serif);
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 0.02em;
    color: rgba(245,242,236,0.75);
    line-height: 1.3;
    transition: color 0.18s;
  }

  .mm-cruise-card:hover .mm-cruise-card__name {
    color: var(--color-ivory);
  }

  .mm-cruise-card__meta {
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.06em;
    color: rgba(201,165,106,0.6);
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .mm-cruise-card__cabins {
    font-size: 11px;
    line-height: 1.3;
    display: inline-flex;
    align-items: center;
  }

  .mm-cruise-card__dot {
    opacity: 0.4;
  }

  .mm-cruise-card__stars {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    color: var(--color-gold);
  }
`
